import { store } from "../store/store";
const API_SUFFIX = process.env.VUE_APP_API_SUFFIX;
export default class {
  static apiRequest(url = ``, data = {}, method = "POST") {
    if (!store.getters.getAppLoading) {
      store.commit("setAppLoading", true);
    }
    return fetch(url, {
      method: method,
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      redirect: "follow",
      referrer: "no-referrer",
      body: method === "GET" || method === "HEAD" ? null : JSON.stringify(data)
    }).then(response => {
      if (store.getters.getAppLoading) {
        store.commit("setAppLoading", false);
      }
      if (response.status === 401) {
        this.unauth();
      }
      if (response.status === 404) {
        throw new Error("404");
      }
      if (response.status !== 200 && response.status !== 201) {
        throw new Error("Invalid response error");
      }
      return response.json();
    });
  }

  static apiUpload(url = ``, data = {}) {
    return fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "include",
      redirect: "follow",
      referrer: "no-referrer",
      body: data
    }).then(response => {
      if (response.status === 401) {
        this.unauth();
      }
      if (response.status !== 200) throw new Error();
      return response.json();
    });
  }

  static unauth() {
    if (store.getters.getAuthed) {
      store.commit("setAuthed", false);
      window.location.reload();
    }
  }
}
